export const SET_GROUPS = 'SET_GROUPS'
export const CLEAR_GROUPS = 'CLEAR_GROUPS'
export const SET_GROUP = 'SET_GROUP'
export const CLEAR_GROUP = 'CLEAR_GROUP'

export const PREV_GUEST = 'PREV_GUEST'
export const NEXT_GUEST = 'NEXT_GUEST'

export const UPDATE_ATTENDING = 'UPDATE_ATTENDING'
export const REMOVE_DIETARY_RESTRICTION = 'REMOVE_DIETARY_RESTRICTION'
export const ADD_DIETARY_RESTRICTION = 'ADD_DIETARY_RESTRICTION'
export const UPDATE_DIETARY_NOTES = 'UPDATE_DIETARY_NOTES'
export const UPDATE_SONG = 'UPDATE_SONG'

export const SET_SONGS = 'SET_SONGS'
export const CLEAR_SONGS = 'CLEAR_SONGS'

export const SHOW_RSVP_SUCCESS = 'SHOW_RSVP_SUCCESS'
export const HIDE_RSVP_SUCCESS = 'HIDE_RSVP_SUCCESS'
export const CLEAR_RSVP = 'CLEAR_RSVP'

export const SET_ALERT = 'SET_ALERT'
export const CLEAR_ALERT_TIMER = 'CLEAR_ALERT_TIMER'
export const HIDE_ALERT = 'HIDE_ALERT'
